import { useQuery, UseQueryOptions } from 'react-query'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import { Listing } from '~/models/Listing/interface'

export const manageAdsConfig = {
  getUserListing: {
    key: 'getUserListing',
    request: async ({ queryKey }) => {
      const [_key, params] = queryKey

      const resp = await EmpriseGroup.getUserListing(params)
      const data = await Deserializer.deserialize(resp)

      return data
    }
  }
}

interface UseGetUserListingQueryProps {
  id: string | string[]
  options?: UseQueryOptions<Listing>
}

export const useGetUserListingQuery = (props?: UseGetUserListingQueryProps) => {
  const { getUserListing: config } = manageAdsConfig
  const { options, id } = props || {}
  const state = useQuery<Listing>([config.key, id], config.request, {
    ...options
  })

  return state
}
